module.exports = __webpack_public_path__ + "static/media/externalEntityGroupsBulkTemplate.5213a088.xlsx";